'use strict';

export default function toggleGlass() {
    let $toggleGlass = $('.js-toggle-glass'),
        $glass = $('.js-glass-holder');

    let getCurrent = ($this, $array) => $array
        .filter(`[data-target="${$this.attr('data-target')}"]`);

    $toggleGlass.on('click', function () {
        let $this = $(this),
            $thisGlass = getCurrent($this, $glass);

        if ($this.hasClass('collapsed')) {
            $thisGlass.addClass('active');
        } else {
            $thisGlass.removeClass('active');
        }
    });

    $glass.on('click', function () {
        let $this = $(this),
            $thisToggleGlass = getCurrent($this, $toggleGlass);

        $thisToggleGlass.trigger('click');
    });
}
